<template>
    <div id="app">
        <div id="window_main">
            <router-view />
        </div>
    </div>
</template>

<script>
const ipcRenderer = window.require ? window.require("electron").ipcRenderer : '';
const minorVersion = 0;
import mixin from '@/mixins/setMenus';
export default {
    name: "App",
    mixins: [mixin],
    data () {
        return {
            dialogVisible: false,
            progress: 0,
            audience: this.$baseUrl.DOWN_KEY,
            appName: this.$baseUrl.DOWN_NAME,
            newVersion: '',
            downloadUrl: '',
            showUpdateInfo: false,
            updateInfo: {},

            network: '',

            maintenanceVis:false,
            maintenanceInfo:{}
        }
    },
    created () {
        // 在页面加载时读取 sessionStorage
        let store = this.$sg.ss.get("store")

        if (store) {
            this.$store.replaceState(
                Object.assign({},
                    this.$store.state,
                    store
                )
            );

        }
        // local存在language则取local，否则取zh
        // let language = 'zh';
        let language = this.$sg.ls.get('language')

        if (language && language != 'undefined') {
            this.$store.commit('setLanguage', language)
        } else {
            this.$store.commit('setLanguage', 'zh')
        }
        // 在页面刷新时将store保存到sessionStorage里
        window.addEventListener("beforeunload", () => {
            this.$sg.ss.set("store", this.$store.state);
        });
    },

    methods: {

    },
};
</script>

<style lang="scss">
#app {
    width: 100%;
    height: 100%;
    min-width: 1280px;
    min-height: 800px;
    background-size: cover;
    overflow: auto;
}

#window_main {
    height: 100%;
    overflow: hidden;
}

pre {
    white-space: pre-wrap;
    word-wrap: break-word;
}

:root {
    --primary-color: #3663e1;
    --primary-hover-color: #3159ca;

    --switch-color-open: rgba(115, 107, 209, 0.3); // switch打开颜色
    --switch-color-close: rgba(175, 175, 175, 0.3); // switch关闭颜色
}
</style>
